import useApi from 'hooks/use-api'
import { useState } from 'react'

type FileToValidateToolLibrary = {
  success: boolean
  error?: string
  uploadFile: (file: File) => Promise<void>
  fileName?: string
}

export const useFileToValidateToolLibrary = (): FileToValidateToolLibrary => {
  const api = useApi()
  const [error, setError] = useState<string>(null)
  const [file, setFile] = useState<File>(null)
  const [success, setSuccess] = useState(false)

  const uploadFile = async (file: File): Promise<void> => {
    setFile(file)
    const formData = new FormData()
    formData.append('file', file)
    try {
      await api('/api/tool-libraries/validate', 'POST', formData)
      setSuccess(true)
    } catch (e) {
      setError(e)
    }
  }

  return {
    error,
    uploadFile,
    success,
    fileName: file?.name ?? null,
  }
}
